// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Full Calendar */

.fc-toolbar-title {
  color: white !important;
}
a.fc-daygrid-day-number {
  width: 100%;
  text-align: center;
}
a.fc-daygrid-day-number {
  width: 100%;
  text-align: center;
}
a.fc-daygrid-day-number {
  width: 100%;
  text-align: center;
}
div.fc-daygrid-event-harness {
  top: unset;
}
.fc-daygrid-event-harness .fc-daygrid-event-harness-abs {
  top: 0px;
  bottom: unset;
}
.fc .fc-scrollgrid-section-header > *,
.fc .fc-scrollgrid-section-footer > * {
  border-right: 0px !important;
}
.fc-theme-standard .fc-scrollgrid {
  border: 0px solid transparent !important;
}

.fc-col-header-cell.fc-day.fc-day-mon {
  color: white;
  border-right: 0px;
  border-left: 0px;
}
.fc-col-header-cell.fc-day.fc-day-tue {
  color: white;
  border-left: 0px;
  border-right: 0px;
}
.fc-col-header-cell.fc-day.fc-day-wed {
  color: white;
  border-right: 0px;
  border-left: 0px;
}
.fc-col-header-cell.fc-day.fc-day-thu {
  color: white;
  border-left: 0px;
  border-right: 0px;
}
.fc-col-header-cell.fc-day.fc-day-fri {
  color: white;
  border-right: 0px;
  border-left: 0px;
}
.fc-col-header-cell.fc-day.fc-day-sat {
  color: white;
  border-left: 0px;
  border-right: 0px;
}
.fc-col-header-cell.fc-day.fc-day-sun {
  color: white;
  border-left: 0px;
  border-right: 0px;
}

.fc-daygrid-event {
  border-radius: 10px !important;
  text-align: center !important;
  font-family: "Plus Jakarta Display" !important;
}
.fc-day {
  color: white;
}
.fc-day.fc-day-mon {
  border: 1px solid !important;
  border-color: #292e5d !important;
}
.fc-day.fc-day-tue {
  border: 1px solid !important;
  border-color: #292e5d !important;
}
.fc-day.fc-day-wed {
  border: 1px solid !important;
  border-color: #292e5d !important;
}
.fc-day.fc-day-thu {
  border: 1px solid !important;
  border-color: #292e5d !important;
}
.fc-day.fc-day-fri {
  border: 1px solid !important;
  border-color: #292e5d !important;
}
.fc-day.fc-day-sat {
  border: 1px solid !important;
  border-color: #292e5d !important;
}
.fc-day.fc-day-sun {
  border: 1px solid !important;
  border-color: #292e5d !important;
}

.fc-scrollgrid.fc-scrollgrid-liquid > td {
  border: 0px;
}

.fc .fc-scrollgrid-section > td {
  border: 0;
}

/* React Kanban */
body .react-kanban-column {
  background: linear-gradient(
    127.09deg,
    rgba(6, 11, 40, 0.94) 19.41%,
    rgba(10, 14, 35, 0.49) 76.65%
  );
  background-color: unset !important;
  border-radius: 15px;
}
.react-kanban-column {
  width: 500px;
}
.react-kanban-card-adder-form {
  width: 100%;
  background-color: red;
  border-radius: 15px;
}
.react-kanban-card-adder-button {
  display: none;
  background-color: red !important;
  border-radius: 15px;
}

/* Text Editor */

body .ql-toolbar.ql-snow {
  background-color: #0f1535 !important;
  border: 0.5px solid #e2e8f04d;
}

body .ql-container.ql-snow {
  background-color: #0f1535 !important;
  border: 0.5px solid #e2e8f04d;
}

body .ql-snow .ql-picker-label {
  color: rgba(255, 255, 255, 0.92) !important;
}

body .ql-snow .ql-stroke {
  stroke: rgba(255, 255, 255, 0.92) !important;
}

body .ql-snow .ql-fill {
  fill: rgba(255, 255, 255, 0.92) !important;
}

/* .ql-snow .ql-picker-label:hover {
    color: rgba(255, 255, 255, 0.92) !important;
  }
  
  .ql-snow .ql-stroke:hover {
    stroke: rgba(255, 255, 255, 0.92) !important;
  }
  
  .ql-snow .ql-fill:hover {
    fill: rgba(255, 255, 255, 0.92) !important;
  } */

.ql-picker-options {
  background: #0f1535 !important;
  border: 0.5px solid #e2e8f04d;
}

.ql-container.ql-snow {
  color: rgb(160, 174, 192);
  min-height: 88px !important;
  border-bottom-left-radius: 15px !important;
  border-bottom-right-radius: 15px !important;
}
`, "",{"version":3,"sources":["webpack://./src/assets/theme/base/plugins.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAElB;EACE,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,QAAQ;EACR,aAAa;AACf;AACA;;EAEE,4BAA4B;AAC9B;AACA;EACE,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,8CAA8C;AAChD;AACA;EACE,YAAY;AACd;AACA;EACE,4BAA4B;EAC5B,gCAAgC;AAClC;AACA;EACE,4BAA4B;EAC5B,gCAAgC;AAClC;AACA;EACE,4BAA4B;EAC5B,gCAAgC;AAClC;AACA;EACE,4BAA4B;EAC5B,gCAAgC;AAClC;AACA;EACE,4BAA4B;EAC5B,gCAAgC;AAClC;AACA;EACE,4BAA4B;EAC5B,gCAAgC;AAClC;AACA;EACE,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE;;;;GAIC;EACD,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,gBAAgB;;AAEhB;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;;;;;;;;;KAUK;;AAEL;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0CAA0C;EAC1C,2CAA2C;AAC7C","sourcesContent":["/* Full Calendar */\n\n.fc-toolbar-title {\n  color: white !important;\n}\na.fc-daygrid-day-number {\n  width: 100%;\n  text-align: center;\n}\na.fc-daygrid-day-number {\n  width: 100%;\n  text-align: center;\n}\na.fc-daygrid-day-number {\n  width: 100%;\n  text-align: center;\n}\ndiv.fc-daygrid-event-harness {\n  top: unset;\n}\n.fc-daygrid-event-harness .fc-daygrid-event-harness-abs {\n  top: 0px;\n  bottom: unset;\n}\n.fc .fc-scrollgrid-section-header > *,\n.fc .fc-scrollgrid-section-footer > * {\n  border-right: 0px !important;\n}\n.fc-theme-standard .fc-scrollgrid {\n  border: 0px solid transparent !important;\n}\n\n.fc-col-header-cell.fc-day.fc-day-mon {\n  color: white;\n  border-right: 0px;\n  border-left: 0px;\n}\n.fc-col-header-cell.fc-day.fc-day-tue {\n  color: white;\n  border-left: 0px;\n  border-right: 0px;\n}\n.fc-col-header-cell.fc-day.fc-day-wed {\n  color: white;\n  border-right: 0px;\n  border-left: 0px;\n}\n.fc-col-header-cell.fc-day.fc-day-thu {\n  color: white;\n  border-left: 0px;\n  border-right: 0px;\n}\n.fc-col-header-cell.fc-day.fc-day-fri {\n  color: white;\n  border-right: 0px;\n  border-left: 0px;\n}\n.fc-col-header-cell.fc-day.fc-day-sat {\n  color: white;\n  border-left: 0px;\n  border-right: 0px;\n}\n.fc-col-header-cell.fc-day.fc-day-sun {\n  color: white;\n  border-left: 0px;\n  border-right: 0px;\n}\n\n.fc-daygrid-event {\n  border-radius: 10px !important;\n  text-align: center !important;\n  font-family: \"Plus Jakarta Display\" !important;\n}\n.fc-day {\n  color: white;\n}\n.fc-day.fc-day-mon {\n  border: 1px solid !important;\n  border-color: #292e5d !important;\n}\n.fc-day.fc-day-tue {\n  border: 1px solid !important;\n  border-color: #292e5d !important;\n}\n.fc-day.fc-day-wed {\n  border: 1px solid !important;\n  border-color: #292e5d !important;\n}\n.fc-day.fc-day-thu {\n  border: 1px solid !important;\n  border-color: #292e5d !important;\n}\n.fc-day.fc-day-fri {\n  border: 1px solid !important;\n  border-color: #292e5d !important;\n}\n.fc-day.fc-day-sat {\n  border: 1px solid !important;\n  border-color: #292e5d !important;\n}\n.fc-day.fc-day-sun {\n  border: 1px solid !important;\n  border-color: #292e5d !important;\n}\n\n.fc-scrollgrid.fc-scrollgrid-liquid > td {\n  border: 0px;\n}\n\n.fc .fc-scrollgrid-section > td {\n  border: 0;\n}\n\n/* React Kanban */\nbody .react-kanban-column {\n  background: linear-gradient(\n    127.09deg,\n    rgba(6, 11, 40, 0.94) 19.41%,\n    rgba(10, 14, 35, 0.49) 76.65%\n  );\n  background-color: unset !important;\n  border-radius: 15px;\n}\n.react-kanban-column {\n  width: 500px;\n}\n.react-kanban-card-adder-form {\n  width: 100%;\n  background-color: red;\n  border-radius: 15px;\n}\n.react-kanban-card-adder-button {\n  display: none;\n  background-color: red !important;\n  border-radius: 15px;\n}\n\n/* Text Editor */\n\nbody .ql-toolbar.ql-snow {\n  background-color: #0f1535 !important;\n  border: 0.5px solid #e2e8f04d;\n}\n\nbody .ql-container.ql-snow {\n  background-color: #0f1535 !important;\n  border: 0.5px solid #e2e8f04d;\n}\n\nbody .ql-snow .ql-picker-label {\n  color: rgba(255, 255, 255, 0.92) !important;\n}\n\nbody .ql-snow .ql-stroke {\n  stroke: rgba(255, 255, 255, 0.92) !important;\n}\n\nbody .ql-snow .ql-fill {\n  fill: rgba(255, 255, 255, 0.92) !important;\n}\n\n/* .ql-snow .ql-picker-label:hover {\n    color: rgba(255, 255, 255, 0.92) !important;\n  }\n  \n  .ql-snow .ql-stroke:hover {\n    stroke: rgba(255, 255, 255, 0.92) !important;\n  }\n  \n  .ql-snow .ql-fill:hover {\n    fill: rgba(255, 255, 255, 0.92) !important;\n  } */\n\n.ql-picker-options {\n  background: #0f1535 !important;\n  border: 0.5px solid #e2e8f04d;\n}\n\n.ql-container.ql-snow {\n  color: rgb(160, 174, 192);\n  min-height: 88px !important;\n  border-bottom-left-radius: 15px !important;\n  border-bottom-right-radius: 15px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
